<template>
  <el-dialog :visible="visible" @update:visible="update">
        <span slot="title" class="text-success">
          <icon name="question-circle"></icon>
          模板使用说明
        </span>
    <ol>
      <li>下载模板，填写时请自行删除模板中的样例内容</li>
      <li v-if="props.length">
        部分字段须按照固定格式填写，这些字段有：
        <div class="m-v-5">
          <div class="item clearfix" v-for="(prop, index) in props" :key="index">
            <div class="item-title">{{prop.name}}：</div>
            <div class="content">
              <span v-if="prop.type === 'select'">{{prop.select.join('、')}}</span>
              <span v-else>{{getFormat(prop.unit)}} 格式，如 {{getSample(prop.unit).join('、')}}</span>
            </div>
          </div>
        </div>
      </li>
      <li>填写完成后进行上传，在网页中进行预览，确认无误后提交即可</li>
    </ol>
    <div slot="footer" class="text-center">
      <el-button type="success" @click="update(false)">我知道了</el-button>
    </div>
  </el-dialog>
</template>
<script>
import dateUtil from 'element-ui/src/utils/date'

export default {
  props: ['visible', 'types'],
  data () {
    return {
      sample_date: ['2016-08-01 12:15', '2015-12-02 12:15'].map(date => dateUtil.parse(date, 'yyyy-MM-dd HH:mm')),
      formats: {date: 'yyyy-MM-dd', month: 'yyyy-MM'},
    }
  },
  computed: {
    props () {
      let list = []
      let map = Object.create(null)
      this.types.forEach(type => {
        type.form.forEach(item => {
          if (map[item.prop] || item.type !== 'select' && item.type !== 'date') return
          map[item.prop] = true
          list.push(item)
        })
      })
      return list
    },
  },
  methods: {
    update (v) {
      this.$emit('update:visible', v)
    },
    getFormat (unit) {
      return this.formats[unit] || this.formats.date
    },
    getSample (unit) {
      let format = this.getFormat(unit)
      return this.sample_date.map(date => dateUtil.format(date, format))
    },
  },
}
</script>
<style lang="scss" scoped>
ol {
  margin: 0;
}

li {
  margin-top: 10px;
  &:first-child {
    margin-top: 0;
  }
}

.item {
  $title-width: 8em;
  .item-title {
    float: left;
    width: $title-width;
    text-align: right;
    padding-right: 1em;
    font-weight: bold;
  }
  .content {
    padding-left: $title-width;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/achievement/TemplateGuideDialog.vue